<template>
  <div class="background">
    <!-- <div class="text-center mt-4 center">
      <<v-alert type="warning" max-width="650" class="d-md-block center d-none"
        >Le site est toujours en cours de développement, il sera disponible
        rapidement !</v-alert
      >
    </div>-->
    <v-container v-if="!isFetching">
      <v-row>
        <v-col cols="2" class="d-none d-xl-flex"> </v-col>
        <v-col>
          <v-row>
            <v-col cols="12" md="6">
              <v-card elevation="2" min-height="750" class="px-4 py-4">
                <Bio :user="user" :adminMod="this.adminMod" />
                <v-divider
                  class="lighten-1 mt-5 mb-3 ml-0 mr-0"
                  v-bind:class="schoolColor"
                ></v-divider>
                <StatsProfile :user="user" />
                <div v-if="user.is_teacher">
                  <v-divider
                    class="lighten-1 mt-5 mb-3 ml-0 mr-0"
                    v-bind:class="schoolColor"
                  ></v-divider>
                  <BtnAddCourse :user="user" :isAdminMode="adminMod" />
                  <!-- <v-btn
                    color="primary"
                    class="mt-4"
                    large
                    @click="dialog_notifications = true"
                  >
                    <v-icon class="mr-1">mdi-bell</v-icon> Gérer mes
                    notifications
                  </v-btn> -->
                  <!-- <v-btn
                    color="warning"
                    class="mt-4"
                    large
                    @click="dialog_edit_teacher = true"
                  >
                    <v-icon class="mr-1">mdi-pencil</v-icon> Modifier
                    préférences
                  </v-btn> -->
                  <v-dialog v-model="dialog_notifications" width="600">
                    <DialogNotifications
                      :user="user"
                      @close="dialog_notifications = false"
                    />
                  </v-dialog>
                  <v-dialog v-model="dialog_edit_teacher" width="600">
                    <DialogTeacherProfiles
                      :user="user"
                      @close="dialog_edit_teacher = false"
                    />
                  </v-dialog>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card
                height="750"
                class="overflow-y-auto pa-2 mb-8"
                v-scroll.self="onScroll"
              >
                <CourseApplicationViewer :user="user" :adminMod="adminMod" />
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2" class="d-none d-xl-flex"> </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Bio from "../components/Bio.vue";
import StatsProfile from "../components/StatsProfile.vue";
import CourseApplicationViewer from "../components/CourseApplicationViewer.vue";
import DialogTeacherProfiles from "../components/DialogTeacherProfiles.vue";
import DialogNotifications from "../components/DialogNotifications.vue";
import BtnAddCourse from "../components/BtnAddCourse.vue";
import { mapGetters } from "vuex";
// import dayjs from "dayjs";

export default {
  name: "Profile",

  components: {
    DialogTeacherProfiles,
    Bio,
    StatsProfile,
    CourseApplicationViewer,
    BtnAddCourse,
    DialogNotifications,
  },

  data: () => ({
    isFetching: true,
    adminMod: false,
    dialog_edit_teacher: false,
    dialog_notifications: false,

    scrollInvoked: 0,
  }),
  computed: {
    ...mapGetters({
      currentUser: "user/getUser",
      specificUser: "admin/getSpecificUser",
    }),
    schoolColor: function () {
      return this.user.school;
    },
    user: function () {
      if (this.$route.params.memberid == undefined) {
        return this.currentUser;
      } else {
        return this.specificUser;
      }
    },
  },
  methods: {
    returnSchool() {
      return this.user.school;
    },
    onScroll() {
      this.scrollInvoked++;
    },
  },
  beforeMount() {
    if (this.$route.params.memberid == undefined) {
      this.isFetching = false;
    } else {
      this.adminMod = true;
      this.$store
        .dispatch("admin/getUserById", this.$route.params.memberid)
        .finally(() => {
          this.isFetching = false;
        });
    }
  },
};
</script>

<style scoped>
.background {
  background-color: #d6d6d6;
  background-image: url(../assets/bg_white_wave.png);
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
  width: auto;
}

.center {
  margin: auto;
  width: 60%;
}

@media screen and (max-width: 1200px) {
  .responsive {
    display: flex;
    flex-direction: column;
  }

  .stats {
    display: flex;
    flex-direction: column;
  }
}
</style>
